import * as tslib_1 from "tslib";
import { GeneralOptions } from 'owa-options-general';
import { MailOptions } from 'owa-options-mail';
import { CalendarOptions } from 'owa-options-calendar';
import { PremiumOptions } from 'owa-options-premium';
import 'owa-options-mail'; // Imported to bootstrap several services
import { computed } from 'mobx';
export var UNFILTERED_OPTIONS = [
    GeneralOptions,
    MailOptions,
    CalendarOptions,
    PremiumOptions,
];
var collectedOptions = computed(function () {
    return UNFILTERED_OPTIONS.map(function (category) {
        category = tslib_1.__assign({}, category, { subcategories: category.subcategories
                .map(function (subcategory) {
                subcategory = tslib_1.__assign({}, subcategory, { options: subcategory.options.filter(function (option) { return !option.isHidden || !option.isHidden(); }) });
                return subcategory;
            })
                .filter(function (subcategory) { return subcategory.options.length > 0; }) });
        return category;
    }).filter(function (category) { return category.subcategories.length > 0; });
});
export default (function () { return collectedOptions.get(); });
//# sourceMappingURL=collectedOptions.js.map